import { Suspense } from 'react';
import { Loading } from 'components';

export const SuspenseWrapper = ({ children }) => {
  return <Suspense fallback={<Loading />}>{children}</Suspense>;
};
